import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgCirclePlusIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("circle", {
    cx: 8,
    cy: 8,
    r: 7.4,
    stroke: "currentColor",
    strokeWidth: 1.2
  }), jsx("path", {
    fill: "currentColor",
    d: "M4 7.35h8v1.2H4z"
  }), jsx("path", {
    fill: "currentColor",
    d: "M7.4 11.95v-8h1.2v8z"
  }));
}

export { SvgCirclePlusIcon as default };
